"use client";

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import type { LibraryItem } from "@/lib/mock/library";

interface LibraryVideoModalProps {
  item: LibraryItem | null;
  onClose: () => void;
}

export function LibraryVideoModal({ item, onClose }: LibraryVideoModalProps) {
  const muxPlaybackId = item?.muxPlaybackId;
  const youtubeUrl = item?.youtubeUrl;
  const hasVideo = Boolean(muxPlaybackId || youtubeUrl);

  return (
    <Dialog open={Boolean(item && hasVideo)} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[900px] gap-0 overflow-hidden p-0">
        <DialogHeader className="border-b border-white/10 px-5 py-4">
          <DialogTitle className="pr-8 text-base leading-snug">
            {item?.title}
          </DialogTitle>
        </DialogHeader>
        {hasVideo && (
          <div className="relative aspect-video w-full bg-black">
            {muxPlaybackId ? (
              <video
                src={`https://stream.mux.com/${muxPlaybackId}/highest.mp4`}
                poster={item?.thumbnailUrl ?? undefined}
                controls
                autoPlay
                playsInline
                preload="auto"
                className="absolute inset-0 h-full w-full bg-black"
              />
            ) : youtubeUrl ? (
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${youtubeUrl.split('v=')[1]?.split('&')[0]}?autoplay=1&rel=0&modestbranding=1`}
                title={item?.title ?? "Xynth video"}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                className="absolute inset-0"
              />
            ) : null}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
